import { CommonModule } from '@angular/common';
import { Component, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-ai-panel',
  templateUrl: './ai-panel.html',
  standalone: true,
  imports: [AngularSvgIconModule, CommonModule, FormsModule],
})
export class AiPanel {
  showChat = model.required();
  showSimXpert = model.required();
}
